import {readApiMessageEn} from '@/shared/lib/utils/errors/apiError';

export type TariffType = 'by_count' | 'by_date';

/** Бэкенд отвечает так, когда пользователь израсходовал 3 бесплатных документа. */
const FREE_TARIFF_USED = 'Free tariff already used';

/**
 * «Активного тарифа нет» бэкенд отдаёт ошибкой, поэтому бизнес-ответ приходится отличать
 * от сбоя по статусу: 4xx (кроме отказа авторизации) — сервер ответил по существу,
 * всё остальное — нет ответа, авария шлюза или истёкшая сессия.
 *
 * Выдавать сбой за истёкший тариф нельзя: на этот ответ завязаны диалог «выберите тариф»
 * и удаление черновика, а сетевой сбой о тарифе не говорит ничего.
 *
 * @returns тип тарифа для бизнес-ответа, null — если ошибку надо пробросить дальше.
 */
export function resolveNoActiveTariff(e: unknown): TariffType | null {
    const response = (e as {response?: {status?: number; data?: unknown}} | null)?.response;
    const status = response?.status;

    if (!status || status >= 500 || status === 401 || status === 403) return null;

    return readApiMessageEn(response?.data) === FREE_TARIFF_USED ? 'by_count' : 'by_date';
}
